import { useState, useEffect } from "react";
import axios from "axios";
import { FloatingLabel } from "flowbite-react";

const AddBank = ({
  beneficiaryNameDetails,
  villageCodebank,
  KhataNobank,
  compensationsId,
}) => {
  const [error, setError] = useState([]);
  const [consent, setConsent] = useState(null);
  const [CancelChequeFile, setCancelChequeFile] = useState([]);
  const [beneficiaryBankDetails, setBeneficiaryBankDetails] = useState([]);
  const [favourname, setFavourName] = useState();
  const [beneficiaryname, setBN] = useState();
  const [beneficiarynamebank, setBeneficiaryNameBank] = useState();

  const [insertBankDetails, setInsertBankDetails] = useState({
    BenefiaciaryId: "",
    AccountHolderName: "",
    AccountNo: "",
    IFSCCode: "",
    Bank: "",
    Branch: "",
    CancelChequeFile: "",
  });

  const addpoa = () => {
    alert("Add POA");
  };
  console.log("beneficiaryNameDetails", beneficiaryNameDetails);
  console.log("villageCodebank", villageCodebank);
  console.log("KhataNobank", KhataNobank);

  const fetchBeneficiaryBankDetails = async () => {
    try {
      const response = await fetch(
        `https://backurrda.sarmar.co.in/api/Beneficiary/GetBeneficiaryBankDetails?compensationId=${compensationsId}&villageCode=${villageCodebank}&khataNo=${KhataNobank}`
      );
      if (response.ok) {
        const data = await response.json();
        setBeneficiaryBankDetails(data);
        console.log("BeneficiaryNameDetails", data);
      } else {
        console.error(
          "Failed to fetch BeneficiaryDetails. HTTP Status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching BeneficiaryDetails:", error);
    }
  };
  useEffect(() => {
    fetchBeneficiaryBankDetails();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCancelChequeFile(file);
      setInsertBankDetails({
        ...insertBankDetails,
        CancelChequeFile: file, // Ensure capitalization matches
      });
      console.log("File selected:", file);
    } else {
      console.error("No file selected");
    }
  };

  const insertBankData = async () => {
    debugger;

    const formData = new FormData();
    formData.append("CompensationId", compensationsId || "");
    formData.append("BeneficiaryId", insertBankDetails.BenefiaciaryId || "");
    formData.append("VillageCode", villageCodebank || "");
    formData.append("KhataNo", KhataNobank || "");
    formData.append(
      "AccountHolderName",
      insertBankDetails.AccountHolderName || ""
    );
    formData.append("AccountNo", insertBankDetails.AccountNo || "");
    formData.append("IFSCCode", insertBankDetails.IFSCCode || "");
    formData.append("Bank", insertBankDetails.Bank || "");
    formData.append("Branch", insertBankDetails.Branch || "");

    // Ensure CancelChequeFile exists before appending
    if (CancelChequeFile && CancelChequeFile instanceof File) {
      formData.append("CancelChequeFile", CancelChequeFile);
    } else {
      console.error("Invalid or no Cancel Cheque File selected.");
    }

    try {
      const response = await axios.post(
        "https://backurrda.sarmar.co.in/api/Beneficiary/InsertBeneficiaryBankDetails",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200 && response.data) {
        console.log("Response:", response.data);
        alert("Bank details saved successfully!");
        fetchBeneficiaryBankDetails();

        // Reset form and state
        setInsertBankDetails({
          BenefiaciaryId: "",
          AccountHolderName: "",
          AccountNo: "",
          IFSCCode: "",
          Bank: "",
          Branch: "",
          CancelChequeFile: null,
        });
        setCancelChequeFile(null);
      } else {
        throw new Error(
          response.data?.message || "Failed to save bank details."
        );
      }
    } catch (err) {
      console.error("Error in Insert Bank Data API:", err);
      alert(
        "Error saving bank details: " +
          (err.response?.data?.message || err.message)
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      await insertBankData();
    } catch (err) {
      console.error("Error in Add Bank Details:", err);
      setError(err.message);
      alert("Error: " + err.message);
    }
  };

  useEffect(() => {
    // Any required logic on mount
  }, []);

  const getFileUrl = (filePath) => {
    if (!filePath) return null; // Return null if the file path is empty
    const fileName = filePath.split("\\").pop(); // Extract file name
    return `https://backurrda.sarmar.co.in/api/Files/view/${fileName}`;
  };
  return (
    <div className="flex-1 px-1 sm:px-6 py-1 overflow-auto">
      {/* Header Section */}
      <div className="border-b pb-1 flex items-center justify-between text-lg font-bold">
        <h1>Beneficiary Bank Details</h1>
      </div>

      {/* Consent Section */}
      <h2 className="text-[#241C68] underline mb-1"> &#x25CF; Consent</h2>
      <span className="text-red-600">
        Whether Power Of Attorney is given in Favour of Single Beneficiary?
      </span>
      <div className="mt-1 flex">
        <label className="flex items-center">
          <input
            type="radio"
            name="consent"
            value="yes"
            checked={consent === "yes"}
            onChange={() => setConsent("yes")}
          />
          <span className="ml-2">Yes</span>
        </label>
        <label className="flex items-center ml-6">
          <input
            type="radio"
            name="consent"
            value="no"
            checked={consent === "no"}
            onChange={() => setConsent("no")}
          />
          <span className="ml-2">No</span>
        </label>
      </div>

      {/* Beneficiary Section */}
      {consent === "yes" && (
        <section className="mt-1">
          <div className="grid grid-cols-8 gap-2">
            <div className="col-span-2">
              <label>
                Select Beneficiary
                <select
                  className="border rounded-md p-2 w-full"
                  name="Beneficiary"
                  value={beneficiaryname}
                  // onChange={(e) =>
                  //   setBN({
                  //     ...insertBankDetails,
                  //     BenefiaciaryId: e.target.value,
                  //   })
                  // }
                  onChange={(e) => {
                    setBN(e.target.value);
                  }}
                >
                  <option value="">Select Beneficiary</option>
                  {beneficiaryNameDetails
                    .filter(
                      (item) =>
                        item.BenefiaciaryId !== insertBankDetails.BenefiaciaryId
                    ) // Filter out already selected Beneficiary
                    .map((item) => (
                      <option
                        key={item.BenefiaciaryId}
                        value={item.BenefiaciaryId}
                      >
                        {item.Name}
                      </option>
                    ))}
                </select>
              </label>
            </div>
            <div className="col-span-2">
              <label htmlFor="">In Favour of</label>
              <select
                className="border rounded-md p-2 w-full"
                name="Beneficiary"
                value={favourname}
                // onChange={(e) =>
                //   setFavourName({
                //     ...insertBankDetails,
                //     BenefiaciaryId: e.target.value,
                //   })
                // }
                onChange={(e) => {
                  setFavourName(e.target.value);
                }}
              >
                <option value="">Select Beneficiary</option>
                {beneficiaryNameDetails.map((item) => (
                  <option key={item.BenefiaciaryId} value={item.BenefiaciaryId}>
                    {item.Name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-span-2">
              <label className="ml-2">
                Upload Power of Attorney
                <div class="flex items-center justify-center">
                  <label
                    for="dropzone-file"
                    class="flex flex-col items-center justify-center w-full h-10 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:bg-white hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-200"
                  >
                    <div class="flex items-center justify-end pt-5 pb-6">
                      <p class="text-md text-gray-500 dark:text-gray-400 mr-2">
                        📄 Power of Attorney
                      </p>
                      <svg
                        class="w-4 h-4 mb- text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      {/* <p class="mb-2 text-sm text-gray-500 dark:text-gray-400"><span class="font-semibold">Click to upload</span> or drag and drop</p> */}
                    </div>
                    <input id="dropzone-file" type="file" class="hidden" />
                  </label>
                </div>
              </label>
            </div>
            <div className="justify-center items-center col-span-2 my-auto ">
              <button
                onClick={addpoa}
                className="border bg-[#241C68] text-white rounded-md p-2 w-full mt-4"
              >
                Save
              </button>
            </div>
          </div>
        </section>
      )}
      {/* Bank Details Section */}
      <section className="mt-2">
        <h2 className="text-[#241C68] underline mb-4">
          &#x25CF; Bank Details:
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Beneficiary Select Dropdown */}
          <div className="relative col-span-2">
            <div className="form-floating">
              <select
                className="form-select block w-full px-2.5 pb-2.5 pt-5 text-sm text-gray-900 bg-gray-50 dark:bg-gray-700 border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                // id="floatingSelect"
                id="VillageCode"
                name="Beneficiary"
                value={insertBankDetails.BenefiaciaryId}
                onChange={(e) =>
                  setInsertBankDetails({
                    ...insertBankDetails,
                    BenefiaciaryId: e.target.value,
                  })
                }
              >
                <option value="">Select Beneficiary</option>
                {beneficiaryNameDetails.map((item) => (
                  <option key={item.BenefiaciaryId} value={item.BenefiaciaryId}>
                    {item.Name}
                  </option>
                ))}
              </select>
              <label
                htmlFor="floatingSelect"
                className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
              >
                Beneficiary
              </label>
            </div>
            {/* <select
            className="border rounded-md p-2 w-full"
            name="Beneficiary"
            value={insertBankDetails.BenefiaciaryId}
            onChange={(e) =>
              setInsertBankDetails({
                ...insertBankDetails,
                BenefiaciaryId: e.target.value,
              })
            }
          >
            <option value="">Select Beneficiary</option>
            {beneficiaryNameDetails.map((item) => (
              <option key={item.BenefiaciaryId} value={item.BenefiaciaryId}>
                {item.Name}
              </option>
            ))}
          </select> */}
          </div>
          <div className="col-span-2">
            <FloatingLabel
              variant="standard"
              label="Account No"
              className="mt-2 w-full"
              name="Block"
              value={insertBankDetails.AccountNo}
              onChange={(e) =>
                setInsertBankDetails({
                  ...insertBankDetails,
                  AccountNo: e.target.value,
                })
              }
            />
          </div>
          <div className="col-span-2">
            <FloatingLabel
              variant="standard"
              label="Account Holder Name"
              className="mt-2 w-full"
              name="Block"
              value={insertBankDetails.AccountHolderName}
            onChange={(e) =>
              setInsertBankDetails({
                ...insertBankDetails,
                AccountHolderName: e.target.value,
              })
            }
            />
          </div>
          <div className="col-span-2">
            <FloatingLabel
              variant="standard"
              label="IFSC Code"
              className="mt-2 w-full"
              name="Block"
              value={insertBankDetails.IFSCCode}
              onChange={(e) =>
                setInsertBankDetails({
                  ...insertBankDetails,
                  IFSCCode: e.target.value,
                })
              }
            />
          </div>
          <div className="col-span-2">
            <FloatingLabel
              variant="standard"
              label="Bank"
              className="mt-2 w-full"
              name="Block"
              value={insertBankDetails.Bank}
              onChange={(e) =>
                setInsertBankDetails({
                  ...insertBankDetails,
                  Bank: e.target.value,
                })
              }
            />
          </div>
          <div className="col-span-2">
            <FloatingLabel
              variant="standard"
              label="Branch"
              className="mt-2 w-full"
              name="Block"
              value={insertBankDetails.Branch}
              onChange={(e) =>
                setInsertBankDetails({
                  ...insertBankDetails,
                  Branch: e.target.value,
                })
              }
            />
          </div>
          {/* <input
            type="text"
            className="border rounded-md p-1 w-full"
            placeholder="Account Holder Name"
            value={insertBankDetails.AccountHolderName}
            onChange={(e) =>
              setInsertBankDetails({
                ...insertBankDetails,
                AccountHolderName: e.target.value,
              })
            }
          />
          <input
            type="text"
            className="border rounded-md p-1 w-full"
            placeholder="IFSC Code"
            value={insertBankDetails.IFSCCode}
            onChange={(e) =>
              setInsertBankDetails({
                ...insertBankDetails,
                IFSCCode: e.target.value,
              })
            }
          /> 
          <input
            type="text"
            className="border rounded-md p-1 w-full"
            placeholder="Bank"
            value={insertBankDetails.Bank}
            onChange={(e) =>
              setInsertBankDetails({
                ...insertBankDetails,
                Bank: e.target.value,
              })
            }
          />
          <input
            type="text"
            className="border rounded-md p-1 w-full"
            placeholder="Branch"
            value={insertBankDetails.Branch}
            onChange={(e) =>
              setInsertBankDetails({
                ...insertBankDetails,
                Branch: e.target.value,
              })
            }
          />*/}

          {/* Cancel Cheque Upload */}
          <div className="flex items-center justify-center">
            <label
              htmlFor="CancelChequeFile"
              className="mr-2 flex flex-col items-center justify-center h-10 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
            >
              <div className="flex items-center justify-center pt-5 pb-6">
                <p className="text-md text-gray-500 mr-2">📄 Cancel Cheque</p>
              </div>
            </label>
            <input
              id="CancelChequeFile"
              name="CancelChequeFile"
              type="file"
              accept=".pdf,.doc,.docx"
              onChange={handleFileChange}
              className="absolute w-0 h-0 opacity-0"
            />
          </div>

          {/* Submit Button */}
          <button
            className="w-full bg-[#241C68] text-white py-2 rounded-md"
            onClick={handleSubmit}
          >
            Add
          </button>
        </div>
      </section>

      {/* Table Section */}
      {/* Table Section */}
      <section className="mt-10">
        <table className="w-full border-collapse border border-gray-300">
          <thead className="text-sm">
            <tr className="bg-gray-100">
              <th className="border border-gray-300 p-2">Beneficiary</th>
              <th className="border border-gray-300 p-2">
                Account Holder Name
              </th>
              <th className="border border-gray-300 p-2">Account No</th>
              <th className="border border-gray-300 p-2">Bank</th>
              <th className="border border-gray-300 p-2">Branch</th>
              <th className="border border-gray-300 p-2">IFSC Code</th>
              <th className="border border-gray-300 p-2">Cancel Cheque</th>
            </tr>
          </thead>
          <tbody className="text-xs">
            {beneficiaryBankDetails?.map((detail, index) => (
              <tr key={index}>
                <td className="border border-gray-300 p-2">
                  <input
                    className="w-full"
                    type="text"
                    value={detail.BeneficiaryName}
                    readOnly
                  />
                </td>
                <td className="border border-gray-300 p-2">
                  <input
                    className="w-full"
                    type="text"
                    value={detail.AccountHolderName}
                    readOnly
                  />
                </td>
                <td className="border border-gray-300 p-2">
                  <input
                    className="w-full"
                    type="text"
                    value={detail.AccountNumber}
                    readOnly
                  />
                </td>
                <td className="border border-gray-300 p-2">
                  <input
                    className="w-full"
                    type="text"
                    value={detail.Bank}
                    readOnly
                  />
                </td>
                <td className="border border-gray-300 p-2">
                  <input
                    className="w-full"
                    type="text"
                    value={detail.Branch}
                    readOnly
                  />
                </td>
                <td className="border border-gray-300 p-2">
                  <input
                    className="w-full"
                    type="text"
                    value={detail.IFSCCode}
                    readOnly
                  />
                </td>
                <td className="border border-gray-300 p-2 text-center">
                  {detail.CancelCheque ? (
                    <a
                      href={getFileUrl(detail.CancelCheque)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 underline"
                    >
                      View
                    </a>
                  ) : (
                    "N/A"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      {/* Save Button */}
      {/* <button className="border bg-[#241C68] text-white w-1/3 justify-center items-center mt-4 py-2 rounded-lg">
        Save
      </button> */}
    </div>
  );
};

export default AddBank;
